import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import type { TabItem } from '@wix/da-ds/pkg/Tabs';
import { StudioSection } from '../../../types/store';
import { getActiveSection } from '../../../selectors/studio';

import s from './DraftsTabs.scss';

interface Props {}

const DraftsTabs: FC<Props> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const activeTab = useSelector(getActiveSection);

  return (
    <UnderlinedTabs
      className={s['root']}
      uniformTabWidth={isMobile}
      items={
        [
          {
            label: t('studio.header.tabs.drafts.subtabs.media'),
            index: StudioSection.DRAFTS,
            href: Url.studio(),
          },
          {
            label: t('studio.header.tabs.drafts.subtabs.literature'),
            index: StudioSection.LITERATURE,
            href: Url.studio({ section: 'literature' }),
          },
          {
            label: t('studio.header.tabs.drafts.subtabs.journals'),
            index: StudioSection.JOURNALS,
            href: Url.studio({ section: 'journals' }),
          },
          !isMobile && {
            label: t('studio.header.tabs.drafts.subtabs.scheduled'),
            index: StudioSection.SCHEDULED,
            href: Url.studio({ section: 'scheduled' }),
          },
        ].filter(item => !!item) as TabItem[]
      }
      activeIndex={activeTab}
    />
  );
};

DraftsTabs.displayName = 'DraftsTabs';

export default DraftsTabs;
